import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { client, urlFor } from "../../sanityClient";
import { PortableText } from "@portabletext/react";
import usePageMeta from "../../hooks/usePageMeta"; // 1. Import hook
import "./SinglePost.css";

function SinglePost() {
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const { slug } = useParams();

  // 2. We don't call the hook here, we wait for the data

  useEffect(() => {
    const query = `*[_type == "post" && slug.current == $slug][0]`;
    const params = { slug: slug };

    client.fetch(query, params).then((data) => {
      setPost(data);
      setLoading(false);
    });
  }, [slug]);

  // 3. Set the meta tags AFTER the post data has been fetched
  usePageMeta(
    post ? `${post.title} | TjWit Media Blog` : "Loading Blog Post...",
    post
      ? "A blog post from TjWit Media about sports photography."
      : "Loading content from the TjWit Media blog."
  );

  if (loading) {
    return (
      <div className="single-post-container">
        {" "}
        <h1>Loading post...</h1>{" "}
      </div>
    );
  }
  if (!post) {
    return (
      <div className="single-post-container">
        {" "}
        <h1>Post not found.</h1>{" "}
      </div>
    );
  }

  return (
    <div className="single-post-container">
      <header className="post-header">
        <h1>{post.title}</h1>
        <p className="post-meta">
          {" "}
          Published on: {new Date(post.publishedAt).toLocaleDateString()}{" "}
        </p>
      </header>
      {post.mainImage && (
        <img
          src={urlFor(post.mainImage).width(800).url()}
          alt={post.title}
          className="post-main-image"
        />
      )}
      <div className="post-body">
        {" "}
        <PortableText value={post.body} />{" "}
      </div>
    </div>
  );
}
export default SinglePost;
